import { render, staticRenderFns } from "./fallback.vue?vue&type=template&id=09420aa6&scoped=true"
import script from "./fallback.ts?vue&type=script&lang=ts&external"
export * from "./fallback.ts?vue&type=script&lang=ts&external"
import style0 from "./fallback.less?vue&type=style&index=0&id=09420aa6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09420aa6",
  null
  
)

export default component.exports